import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyHandler } from "@/services/shared";
import type { ApiCompanyType, CompanyType } from "@/types";

interface ApiDisableResponseInterface {
    company?: ApiCompanyType,
    data?: ApiCompanyType,
    message?: string,
}

export const disableCompanyHandler = async (id: number | string): Promise<CompanyType> => {
    const response = await axiosClient.put<ApiDisableResponseInterface>(adminCompaniesEndpoints.disable(id));

    const company = response.data.data ?? response.data.company;

    if (!company) throw new Error("Company payload missing in disable response");

    return transformApiCompanyHandler(company);
};
